import React, { useEffect, useState } from "react";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { errorToast } from "../../helpers";
import MainContainer from "../../layout/MainContainer";
import QuoteChat from "../../components/quoteChat";
import useTranslation from "../../hooks/Translation";

const QuotesChatDetails = () => {
  const { userId, id } = useParams();
  const [rows, setRows] = useState<any[]>([]);
  const t = useTranslation();
  const location = useLocation();
  const { state } = location;
  console.log(state);
  const navigate = useNavigate();

  return (
    <div>
      <div className="main_layout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.main.chatDetails}</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate(`/manage-quotes`, { state: { value: state?.value } });
            }}
          >
            {t.main.back}
          </Button>
        </div>
        <QuoteChat sessionId={state?.sessionId} />
      </div>
    </div>
  );
};

export default QuotesChatDetails;
